import { LanguageContext } from '@/context/LanguageContext';
import { TranslateScope } from  '@/interfaces/languages';
import React, { useContext } from 'react';

const QuickTranslateQ3 = () => {

    const languageContext = useContext(LanguageContext);

    function langSlectionString() {

        let langStr = ""

        if (languageContext.store.languageSelected){

            const len = languageContext.store.languageSelected.length;

            languageContext.store.languageSelected.forEach((x,i) => {

                
                const current = i + 1;
                langStr += x.name;
                
                if (current < len - 1 ){
                   langStr += ", "
                }
                else if (len >= 2 && current === len - 1 ){
                    langStr += " and "
                }

            })

        }

        return langStr;

    }

    return (
        <div className='qt-review'>
            
            <p>
                Please review your selections. You can click on the steps above or use navigate back to previous steps to change your selections. When you are ready, click the 'Translate' button to start translating content automatically in the background.
            </p>

            <div className='review-table'>
                <h3>Language(s) Selected:</h3>
                <span>{langSlectionString()}</span>

                <h3>Language Action:</h3>
                <p className='action-warning'>
                    {languageContext.store.translateScope === TranslateScope.AllContent ? 
                    'Translate my organisations entire content library (across all workspaces) into my chosen languages.' :
                    'Translate content items within my content library (across all workspaces) that already has translations for other languages.'}
                </p>
            </div>

            <div className='bulk-warning'>
                Thrive will add the content translations you have requested in the background. Depending on the total number of content items, this can take time to process.  Please check back later and use the report to analyse the progress of the bulk translation action.
            </div>

        </div>
    );
};

export default QuickTranslateQ3;